// frontend/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// 1. IMPORTAÇÕES DO ANT DESIGN
import { ConfigProvider, App } from 'antd';
import 'antd/dist/reset.css';

import ptBR from 'antd/lib/locale/pt_BR';
import 'dayjs/locale/pt-br';

import { AuthProvider } from './contexts/AuthContext';
import { DataRefreshProvider } from './contexts/DataRefreshContext';
import { PrivacyProvider } from './contexts/PrivacyContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import ConvitePage from './pages/ConvitePage/ConvitePage.jsx';
import Layout from './components/Layout/Layout.jsx';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute.jsx';
import LegalEnforcer from './components/LegalEnforcer/LegalEnforcer.jsx';
import ModuloRoute from './components/ModuloRoute/ModuloRoute.jsx';

import './styles/theme.css';

// Importação das páginas Financeiras
import LoginPage from './pages/LoginPage/LoginPage.jsx';
import CategoriasPage from './pages/CategoriasPage/CategoriasPage.jsx';
import MeuDesempenhoPage from './pages/MeuDesempenhoPage/MeuDesempenhoPage.jsx';
import TransacoesPage from './pages/TransacoesPage/TransacoesPage.jsx';
import RelatoriosPage from './pages/RelatoriosPage/RelatoriosPage';
import MetasPage from './pages/MetasPage/MetasPage.jsx';
import SimuladoresPage from './pages/SimuladoresPage/SimuladoresPage.jsx';
import ConfiguracoesPage from './pages/ConfiguracoesPage/ConfiguracoesPage.jsx';
import ContasPage from './pages/ContasPage/ContasPage.jsx';
import ContaDetailPage from './pages/ContaDetailPage/ContaDetailPage.jsx';
import CartoesPage from './pages/CartoesPage/CartoesPage.jsx';
import CartaoDetailPage from './pages/CartaoDetailPage/CartaoDetailPage.jsx';
import RecorrenciasPage from './pages/RecorrenciasPage/RecorrenciasPage.jsx';
import RaioXAssinaturasPage from './pages/RaioXAssinaturasPage/RaioXAssinaturasPage.jsx';
import ClientesPage from './pages/ClientesPage/ClientesPage.jsx';
import AReceberPage from './pages/AReceberPage/AReceberPage.jsx';
import ListasComprasPage from './pages/ListasComprasPage/ListasComprasPage.jsx';
import LocalCompraDetailPage from './pages/LocalCompraDetailPage/LocalCompraDetailPage.jsx';
import ListaCompraDetailPage from './pages/ListaCompraDetailPage/ListaCompraDetailPage.jsx';
import HistoricoComprasPage from './pages/HistoricoComprasPage/HistoricoComprasPage.jsx';
import DefinirSenhaOnboardingPage from './pages/DefinirSenhaOnboardingPage.jsx';

// --- CORREÇÃO AQUI: IMPORTS AJUSTADOS PARA AS SUBPASTAS ---
import EsqueciSenhaPage from './pages/EsqueciSenhaPage/EsqueciSenhaPage.jsx';
import RedefinirSenhaConfirmarPage from './pages/RedefinirSenhaConfirmarPage/RedefinirSenhaConfirmarPage.jsx';
import TornarSeParceiroPage from './pages/TornarSeParceiroPage/TornarSeParceiroPage.jsx';
import PainelParceiroPage from './pages/PainelParceiroPage/PainelParceiroPage.jsx';
import CadastroPage from './pages/CadastroPage/CadastroPage.jsx';
import ConfirmarEmailPage from './pages/ConfirmarEmailPage/ConfirmarEmailPage.jsx';
import AcessoBloqueadoPage from './pages/AcessoBloqueadoPage/AcessoBloqueadoPage.jsx';
import CheckoutPage from './pages/CheckoutPage/CheckoutPage.jsx';
import CheckoutSucessoPage from './pages/CheckoutSucessoPage/CheckoutSucessoPage.jsx';
import CheckoutCanceladoPage from './pages/CheckoutCanceladoPage/CheckoutCanceladoPage.jsx';
import MeuPlanoPage from './pages/MeuPlanoPage/MeuPlanoPage.jsx';
import TermosPage from './pages/TermosPage/TermosPage.jsx';
import PrivacidadePage from './pages/PrivacidadePage/PrivacidadePage.jsx';
import AceitarTermosPage from './pages/AceitarTermosPage/AceitarTermosPage.jsx';

// Importação das páginas de Milhas (atuais e novas)
import MilhasPage from './pages/MilhasPage/MilhasPage.jsx';
import PortadorDetailPage from './pages/PortadorDetailPage/PortadorDetailPage.jsx';
import ExtratoMilhasPage from './pages/ExtratoMilhasPage/ExtratoMilhasPage.jsx';
// --- PLACEHOLDERS PARA NOVAS PÁGINAS ---
import ProgramasCatalogoPage from './pages/ProgramasCatalogoPage/ProgramasCatalogoPage.jsx';
import ClubesMilhasPage from './pages/ClubesMilhasPage/ClubesMilhasPage.jsx';
import ControleCpfsPage from './pages/ControleCpfsPage/ControleCpfsPage.jsx';
import ListaBeneficiariosPage from './pages/ListaBeneficiariosPage/ListaBeneficiariosPage.jsx';

import StaffRoute from './components/StaffRoute/StaffRoute.jsx';
import OpsLayout from './pages/Ops/OpsLayout.jsx';
import OpsAuthPage from './pages/Ops/OpsAuthPage.jsx';
import OpsDashboardPage from './pages/Ops/OpsDashboardPage.jsx';
import OpsFaturasPage from './pages/Ops/OpsFaturasPage.jsx';
import OpsPrevisaoPage from './pages/Ops/OpsPrevisaoPage.jsx';
import OpsTaxasPage from './pages/Ops/OpsTaxasPage.jsx';
import './pages/Ops/OpsLayout.css';


const antDesignTheme = {
    token: {
        colorPrimary: '#B89040',
        colorInfo: '#50B0A0',
        colorSuccess: '#2F9E6F',
        colorError: '#D64545',
        colorWarning: '#E6A23C',
        colorText: '#1F4F4F',
        colorTextSecondary: '#5A6A6A',
        colorBorder: '#E8E2D6',
        colorBgContainer: '#FFFFFF',
        colorBgLayout: '#F5F0E6',
        fontFamily: 'Poppins, sans-serif',
        borderRadius: 12,
        controlHeight: 40,
    },
    components: {
        Layout: {
            siderBg: '#1F4F4F',
            triggerBg: '#163D3D',
            headerBg: '#F5F0E6',
            bodyBg: '#F5F0E6',
        },
        Menu: {
            darkItemBg: '#1F4F4F',
            darkSubMenuItemBg: '#163D3D',
            darkItemSelectedBg: '#163D3D',
            darkItemHoverBg: 'rgba(80, 176, 160, 0.18)',
            darkItemSelectedColor: '#B89040',
            darkItemColor: 'rgba(255, 255, 255, 0.75)',
        },
        Card: {
            borderRadiusLG: 12,
        },
        Button: {
            primaryShadow: '0 2px 0 rgba(184, 144, 64, 0.12)',
        },
    },
};

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const hasGoogleOAuth = Boolean(GOOGLE_CLIENT_ID);

function AppRoot() {
    const content = (
        <App>
            <Router>
                <PrivacyProvider>
                    <AuthProvider>
                        <LegalEnforcer>
                        <WorkspaceProvider>
                        <DataRefreshProvider>
                            <Routes>
                                {/* Rotas Públicas */}
                                <Route path="/" element={<Navigate to="/login" />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/cadastro" element={<CadastroPage />} />
                                <Route path="/confirmar-email" element={<ConfirmarEmailPage />} />
                                <Route path="/tornar-se-parceiro" element={<TornarSeParceiroPage />} />
                                <Route path="/acesso-bloqueado" element={<AcessoBloqueadoPage />} />
                                <Route path="/checkout" element={<CheckoutPage />} />
                                <Route path="/checkout/sucesso" element={<CheckoutSucessoPage />} />
                                <Route path="/checkout/cancelado" element={<CheckoutCanceladoPage />} />
                                <Route path="/termos" element={<TermosPage />} />
                                <Route path="/privacidade" element={<PrivacidadePage />} />
                                <Route path="/aceitar-termos" element={<AceitarTermosPage />} />

                                {/* Rota de Onboarding (Definição de senha inicial) */}
                                <Route path="/onboarding/definir-senha/:token" element={<DefinirSenhaOnboardingPage />} />

                                {/* Convite de acesso compartilhado */}
                                {/* Público: se não logado, ConvitePage manda entrar/cadastrar e retoma o fluxo */}
                                <Route path="/convite/:token" element={<ConvitePage />} />

                                {/* --- NOVAS ROTAS DE RECUPERAÇÃO DE SENHA --- */}
                                <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />
                                <Route path="/password-reset/confirm/:uid/:token" element={<RedefinirSenhaConfirmarPage />} />

                                {/* Rotas Protegidas - Financeiras */}
                                <Route path="/meu-desempenho" element={<ProtectedRoute><ModuloRoute modulo="qualquer"><Layout><MeuDesempenhoPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/contas" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><ContasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/contas/:id" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><ContaDetailPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/cartoes" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><CartoesPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/cartoes/:id" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><CartaoDetailPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/transacoes" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><TransacoesPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/listas-compras" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><ListasComprasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/listas-compras/locais/:id" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><LocalCompraDetailPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/listas-compras/:id" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><ListaCompraDetailPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/historico-compras" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><HistoricoComprasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/relatorios" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><RelatoriosPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/recorrencias" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><RecorrenciasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/recorrencias/raio-x-assinaturas" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><RaioXAssinaturasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/metas" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><MetasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/simuladores" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><SimuladoresPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/simuladores/:slug" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><SimuladoresPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/configuracoes" element={<ProtectedRoute><Layout><ConfiguracoesPage /></Layout></ProtectedRoute>} />
                                <Route path="/meu-plano" element={<ProtectedRoute><Layout><MeuPlanoPage /></Layout></ProtectedRoute>} />
                                <Route path="/parceiro" element={<ProtectedRoute><Layout><PainelParceiroPage /></Layout></ProtectedRoute>} />
                                <Route path="/categorias" element={<ProtectedRoute><ModuloRoute modulo="financeiro"><Layout><CategoriasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/clientes" element={<ProtectedRoute><ModuloRoute modulo="prestador"><Layout><ClientesPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/a-receber" element={<ProtectedRoute><ModuloRoute modulo="prestador"><Layout><AReceberPage /></Layout></ModuloRoute></ProtectedRoute>} />

                                {/* Rotas Protegidas - Milhas */}
                                <Route path="/milhas/extrato" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ExtratoMilhasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/milhas/clubes" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ClubesMilhasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/milhas/cpfs" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ControleCpfsPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/milhas/lista-beneficiarios" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ListaBeneficiariosPage /></Layout></ModuloRoute></ProtectedRoute>} />

                                {/* Rotas Protegidas - Gestão (Configurações) */}
                                <Route path="/milhas/portadores" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><MilhasPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/portadores/:id" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><PortadorDetailPage /></Layout></ModuloRoute></ProtectedRoute>} />
                                <Route path="/milhas/programas" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ProgramasCatalogoPage /></Layout></ModuloRoute></ProtectedRoute>} />

                                {/* Gestão Financeira (staff) — acesso via admin bridge ou login staff */}
                                <Route path="/ops/auth" element={<OpsAuthPage />} />
                                <Route path="/ops" element={<StaffRoute><OpsLayout /></StaffRoute>}>
                                    <Route index element={<OpsDashboardPage />} />
                                    <Route path="faturas" element={<OpsFaturasPage />} />
                                    <Route path="previsao" element={<OpsPrevisaoPage />} />
                                    <Route path="taxas" element={<OpsTaxasPage />} />
                                </Route>

                                {/* Rota antiga de extrato */}
                                <Route path="/portadores/:portadorId/programas/:programaId/extrato" element={<ProtectedRoute><ModuloRoute modulo="milhas"><Layout><ExtratoMilhasPage /></Layout></ModuloRoute></ProtectedRoute>} />

                            </Routes>
                        </DataRefreshProvider>
                        </WorkspaceProvider>
                        </LegalEnforcer>
                    </AuthProvider>
                </PrivacyProvider>
            </Router>
        </App>
    );

    return (
        <ConfigProvider theme={antDesignTheme} locale={ptBR}>
            {hasGoogleOAuth ? (
                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    {content}
                </GoogleOAuthProvider>
            ) : (
                content
            )}
        </ConfigProvider>
    );
}

export default AppRoot;